<template>
  <div class="full-width">
    <b-progress v-if="progress" type="is-black" :value="progress"></b-progress>
    <div class="card test" :class="{ shake: shaking }">
      <div class="card-content">
        <slot name="card-content"></slot>
      </div>
      <slot name="card-footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestCard",
  props: ["shaking", "progress", "original", "translated"],
};
</script>
<style lang="scss" scoped>
.full-width {
  width: 100%;
  margin-top: -100px;
  ::v-deep .progress-wrapper {
    padding: 0 30px;
    progress {
      height: 0.4rem;
      -webkit-transition: width 0.5s;
      transition: width 0.5s;
    }
  }
  .card {
    border-radius: 10px;
    &.shake {
      animation-name: shake;
      animation-duration: 1s;
    }
    -webkit-transition: width 0.5s;
    transition: width 0.5s;
    box-shadow: none;
    padding: 10px 0;
    margin-bottom: 20px;
    .card-content {
      padding: 20px 30px;
      .question {
        margin-bottom: 20px;
      }
    }
    .card-footer {
      padding: 10px 10px 0 10px;
      border: 0;
      .card-footer-item {
        padding: 0;
        border: 0 !important;
        justify-content: flex-start;
        &.right {
          justify-content: flex-end;
        }
      }
    }
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-3px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(4px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-8px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(8px, 0, 0);
    }
  }
}
</style>
